<template>
  <div class="shippingAccounts--edit-shippingAccount d-inline pull-left">
    <b-button v-if="!hideAddButton" @click="newshippingAccount" ref="btnShow" size="sm" variant="primary" title="Add New">
      <i class="fa fa-plus" aria-hidden="true"></i>
      Add New
    </b-button>
    <b-modal
      id="edit-shippingAccount-modal"
      ref="editshippingAccountModal"
      size="sm"
      :title="modalTitle"
      @ok="saveShippingAccount"
      @shown="initializeModal"
      @hidden="hideModal"
      :ok-title="isSaving ? 'Saving...' : 'Save'"
      :ok-disabled="isSaving"
      :centered="true"
    >
      <b-row>
        <b-col>
          <b-form-group label="Shipping Provider">
            <b-form-select id="country" v-model="shippingAccount.shippingProviderId">
              <option
                v-for="(provider, index) in sortSelect(shippingProviders)"
                v-bind:key="index"
                v-bind:value="provider.id"
              >{{provider.name}}</option>
            </b-form-select>
          </b-form-group>
          <b-form-group label="Account Number">
            <b-form-input v-model="shippingAccount.accountNumber" />
          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { required } from 'vuelidate/lib/validators';

export default {
  props: [
    'companyId',
    'id',
    'hideAddButton',
    'shippingAccountObj'
  ],
  data() {
    return {
      shippingAccount: {
        shippingProviderId: 0,
        accountNumber: ''
      },
      isSaving: false,
    }
  },
  validations: {
    shippingAccount: {
      shippingProviderId: { required },
      accountNumber: {required }
    },
  },
  computed: {
    ...mapGetters('lookup', [ 'shippingProviders' ]),
    modalTitle() {
      return this.shippingAccount && this.shippingAccount.id ? 'Edit Shipping Account' : 'New Shipping Account';
    },
  },
  methods: {
    ...mapActions('shippingAccount', [
      /*'addNewShippingAccount',
      'editShippingAccount',*/
      'manage'
    ]),
    async initializeModal() {
      this.$v.shippingAccount.$reset();
      if (this.shippingAccountObj) {
        this.shippingAccount.id = this.shippingAccountObj.id;
        this.shippingAccount.shippingProviderId = this.shippingAccountObj.shippingProviderId;
        this.shippingAccount.accountNumber = this.shippingAccountObj.accountNumber;
      }
    },
    hideModal() {
      this.$emit('hideModal');
    },
    newshippingAccount() {
      this.shippingAccount = {};
      this.shippingAccount.id = 0;
      this.shippingAccount.companyId = this.companyId;
      this.show();
    },
    show() {
      this.$v.$reset();
      this.$refs.editshippingAccountModal.show();
    },
    async saveShippingAccount(e) {
      this.$v.shippingAccount.$touch();
      if (this.$v.shippingAccount.$invalid) {
        e.preventDefault();
        return;
      }
      try {
        this.isSaving = true;
        this.shippingAccount.companyId = this.companyId;

        /*if (!this.shippingAccount.id) {
          await this.addNewShippingAccount(this.shippingAccount);
        } else {
          await this.editShippingAccount(this.shippingAccount);
        }*/

        await this.manage(this.shippingAccount);

        this.isSaving = false;

        this.$emit('saved');
        this.$snotify.success('shippingAccount Saved', 'Company Shipping Account');
      } catch (e) {
        this.isSaving = false;
        /*console.log(e.message);*/
      }
    },
  },
}
</script>

<style lang="scss">
.shippingAccount-name {
  margin-bottom: 0px;
}

// #edit-shippingAccount-modal .modal-dialog {
//   width: 650px;
// }
</style>
